module.exports = {
  language: {
    name: '中文'
  },
  header: {
    lang: 'English',
    home: '首页',
    product: '产品展示',
    video: '视频中心',
    news: '新闻动态',
    about: '关于海泰',
    search: '请输入产品关键字',
    langageimg: "en.png",
  },
  footer: {
    lang: 'English',
    home: '首页',
    product: '产品展示',
    video: '视频中心',
    news: '新闻动态',
    about: '关于海泰',
    concact: '地址：广东省汕头市澄海区澄华街道澄江路与安华路交界　联系方式：外销：+86-754-85897999 内销：0754-85688999 ',
    power: 'Copyright 汕头市海泰科技实业有限公司 2022-2030 All Right Reserved ',
    address: '版本所有 <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备18053044号</a><img data-v-40ab164b="" src="https://api.seasuntoys.com/ba.png"><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44051502000423" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44051502000423号</p></a>',
  }
}



// WEBPACK FOOTER //
// ./src/components/language/zh.js